export const TARGET_SELECTOR = '.ui-image-lazyLoad'
export const THRESHOLD = 0
export const LOADED_SELECTOR = 'sw-Image-LazyLoad-Loaded'
